import { useTranslation } from 'react-i18next';
import { Icon, type IconName } from '../../../components/ui/icon.js';

const STEPS: ReadonlyArray<{ icon: IconName; key: string }> = [
  { icon: 'bomb', key: 'mines.howto.step1' },
  { icon: 'gem', key: 'mines.howto.step2' },
  { icon: 'wallet', key: 'mines.howto.step3' },
];

/**
 * Three-beat in-page explainer for Mines: set mines + bet → gems climb the
 * multiplier → cash out before a mine. Sits in the bet rail so a first-time
 * player never has to open the full guide to understand the loop; the link
 * still opens the full rules dialog.
 */
export function MinesHowTo({ onMore }: { onMore: () => void }) {
  const { t } = useTranslation('originals');
  return (
    <div className="mt-4 flex flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[var(--text-muted)]">
          {t('guide.howToPlay')}
        </span>
        <button
          type="button"
          onClick={onMore}
          className="text-[11px] font-semibold text-[var(--primary)] transition-colors hover:text-[var(--text-primary)]"
        >
          {t('guide.title')}
        </button>
      </div>
      <ol className="flex flex-col gap-1.5">
        {STEPS.map((step, i) => (
          <li
            key={step.key}
            className="flex items-center gap-2.5 rounded-lg border border-[var(--border-subtle,var(--border))] bg-[var(--bg-sunken)] px-2.5 py-2"
          >
            <span className="relative grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-[var(--primary)]/12">
              <Icon name={step.icon} size={14} className="text-[var(--primary)]" />
              <span className="absolute -left-1 -top-1 grid h-3.5 w-3.5 place-items-center rounded-full bg-[var(--primary)] text-[9px] font-extrabold leading-none text-[var(--primary-on)]">
                {i + 1}
              </span>
            </span>
            <span className="text-[12px] leading-snug text-[var(--text-secondary)]">{t(step.key)}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
